import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import Select from 'react-select';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class MerchantBrandProductMapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            merchant_list: [],
            brand_list: [],
            category_list: [],
            party_list: [],
            selected_party_type: null,
            selected_party: null,
            upload_user_type: null,
            raw_display_data: [],
            selected_merchant: null,
            selected_brand: null,
            selected_category: null,
            party_master_id: null,
            changedItems: []
        };
        this.handleChange = this.handleChange.bind(this);
    }

    // selected_merchant: 4,
    //         selected_brand: 'HP',
    //         selected_category: 'Laptop',
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this.getPartyID();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        
        //var _notificationSystem = this.refs.notificationSystem;
        // this.getBrandUploadedData();
    }

    getBrandList(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(this.state.selected_merchant);
        this.setState({
            loading:true
        });
        axios.get(config.get('API_URL') + '/brandemi/get_brand_list',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.selected_merchant
            }
        }).then(response => {
            console.log(response);
            let brand_list = [];
            this.setState({
                brand_list: []
            });
            response.data.map((values, index) => {
                brand_list.push({value: values.brand, label: values.brand})
            });
            this.setState({
                brand_list: brand_list,
                loading: false
            })
            this.setState({
                user_id: decoded._id
            });
        });
    }

    preAppender(){
        this.state.raw_display_data.map((value, key) => {
            console.log(value);
            this.setState({
                changedItems: {...this.state.changedItems, [key]:value[1][0].sku + "$" + value[1][0].brand + "$" + value[1][0].description + "$" + value[1][0].category},
                isChange: false
            });
            return null;
        });
    }

    mappingHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', this.state.selected_merchant);
        data.append('mappings', JSON.stringify(this.state.changedItems));
        data.append('userGroup', decoded.userGroup);
        data.append('raw_display',  JSON.stringify(this.state.raw_display_data));
        console.log(data);
        axios.post(config.get('API_URL') + "/brandemi/map_data_new", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.data == 1 || res.data.data == '1'){
                    this.handleNotificationClick("tr", 1, 'Data Successfully Mapped');
                    this.setState({
                        isSubmit:false,
                        loading:false
                    }, () => {
                        this.props.history.push('/admin/merchant-brand-product-mapper')
                    });
                } 
                else {
                    this.handleNotificationClick("tr", 3, 'There was some issue');
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        };


    getMerchantList(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_merchant_list',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id,
            }
        }).then(response => {
            //console.log(response.data);
            let merchant_list = [];
            this.setState({
                merchant_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                merchant_list.push({value: values.id, label: values.party_name})
            });
            this.setState({
                merchant_list: merchant_list,
                loading: false
            })
            this.setState({
                user_id: decoded._id
            });
        });
    }

    

    getCategoryList(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_category_list',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                branda: this.state.selected_brand,
                party_master_id: this.state.selected_merchant
            }
        }).then(response => {
            console.log(response);
            let category_list = [];
            this.setState({
                category_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                category_list.push({value: values.category, label: values.category})
            });
            this.setState({
                category_list: category_list,
                loading: false
            })
            this.setState({
                user_id: decoded._id
            });
        });
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if (decoded.userGroup == 2){
            axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    user_id: decoded._id,
                }
            }).then(response => {
                //console.log(response.data);
                response.data.map((values, index) => {
                    console.log(values.party_id);
                    this.setState({
                        party_master_id: values.party_id,
                        upload_user_type: decoded.userGroup,
                        selected_merchant: values.party_id
                    }, () => {
                        this.getBrandList();
                    });
                })
                this.setState({
                    party_id_mapper: response.data
                });
                $('#party_showTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
            });
        }else{
            this.getMerchantList();
        }
        
    }
    
    getPartyList = () => {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/brandemi/get_party_list', {
                party_type1: this.state.selected_party_type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { console.log(response);
            let party_list = [];
            this.setState({
                party_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                party_list.push({value: values.id, label: values.party_name})
            });
            this.setState({
                party_list: party_list,
                loading: false
            })
        });
    }


    updateMerchant = (valuer) => {
        this.setState({
            selected_merchant: valuer.value
        }, () => {
            this.getBrandList();
        });
        //this.setState({selected_merchant: valuer.value}, this.getBrandList() );
        this.setState({
            uploadDropdown: false
        })
        this.setState({
            loading: true
        })
        
    };

    updateBrand = (valuer) => {
        this.setState({
            selected_brand: valuer.value,
            selected_category: null,
            catetory_list: []
        }, () => {
            this.getCategoryList();
        });
        this.setState({
            uploadDropdown: false
        })
        this.setState({
            loading: true
        })
        
    };

    updateCategory = (valuer) => {
        this.setState({
            selected_category: valuer.value,
            changedItems: [],
            uploadDropdown: false
        });
        // , () => {
        //     this._refreshUnmapped_View();
        // }
    };

    updatePartyType = (valuer) => {
        if (valuer.value == 'Merchant'){
            this.setState({
                selected_party_type: valuer.value,
                uploadDropdown: false,
                upload_user_type: 2
            });
        }
        else if( valuer.value == 'Brand'){
            this.setState({
                selected_party_type: valuer.value,
                uploadDropdown: false,
                upload_user_type: 7
            });
        }
        this.setState({
            loading: true
        });
        this.getPartyList();
    };

    updatePartyValue = (valuer) => {
        this.setState({
            selected_party: valuer.value,
            party_master_id: valuer.value,
            loading: true,
            uploadDropdown: false
        });

    };


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        this.setState({
            open_instructions: !this.state.open_instructions
        });
        
    }

    onChangeHandler = event => {
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
        if (ext === 'csv') {
            this.setState({
                selectedFile: file,
                file_name: file.name
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                selectedFile: file
            });
        }
    };

    handleChange(id, e) {
        console.log(id);
        console.log(e.target.value);
        this.setState({
            changedItems: {...this.state.changedItems, [id]:e.target.value},
            isChange: true
        });
    }
    

    downloadReportCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= file_value;
                console.log(file_value);
                console.log(xhr.getResponseHeader('Content-Disposition'));
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    fileUploadHandler = () => {
        const timer1 = (Date.now()).toString();
        //console.log(timer1);
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        console.log(decoded.userGroup);
        data.append('userGroup', decoded.userGroup);
        data.append('upload_user_type', this.state.upload_user_type);
        data.append('party_master_id', this.state.party_master_id);
        if(this.state.selectedFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedFile; //console.log(data);
            var ext = this.getFileExtension(file.name);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/new_upload/", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(res => {
                    console.log(res.data);
                    this.setState({
                        file_id_got: res.data.file_id,
                        report_file_name: res.data.report_file_name
                    });
                    //console.log(res.data.notify);
                    //console.log(res.data.inconsistent);
                    if (res.data.flag == 2){
                        this.handleNotificationClick("tr", 2, "File with same name uploaded. If you continue, old file will be overwritten.");
                    }
                    else if(res.data.flag == 3){
                        this.handleNotificationClick("tr", 3, "No valid data to upload. File not uploaded");
                    }
                    else if(res.data.flag == 4){
                        this.handleNotificationClick("tr", 3, "Columns are incorrect in your csv");
                    }
                    else if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0 && res.data.error2 === 0) {
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            error_message: res.data.total_value + '/' + res.data.total
                        });
                        console.log("call show method on success");
                        this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                        this.toggleNoErrorModel.bind(this);
                        this.setState({
                            error_message_header: 'Success'
                        })
                        this.getBrandUploadedData();
                    } 
                    
                    else {
                        if (res.data.error2 === 1){
                            this.setState({
                                error_message_header: 'Failure'
                            })
                            this.getBrandUploadedData();
                        }
                        else{
                            this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                            this.toggleNoErrorModel.bind(this);
                            this.setState({
                                error_message_header: 'Success'
                            })
                            this.getBrandUploadedData();
                        }
                        this.setState({
                            isSubmit: false,
                            error_message: res.data.total_value + '/' + res.data.total,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name
                        });
                    }
                })
                .catch(err => { 
                    console.log(err);// then print response status
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit: false,
                        loading: false
                    });
                    // this.openSectionToMap(true); // remove and place in success block
                })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    

    activeHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        if(this.state.activer.length == 0 || this.state.activer.length == 'undefined'){
            this.handleNotificationClick("tr", 3, "No changes applicable");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.activer));
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        axios.post(config.get('API_URL') + "/brandemi/active_updater", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    this.props.history.push('/admin/brand-product-master')
                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })

        }
        
    };
    
    changeStatus(index, stored_file_name, user_id, checked) {
        //let status = 0;
        //if(checked===true){ status = 1 } else { status = 0 }
        this.setState({
            activer: {...this.state.activer, [index]:checked }
        })
    }

    uploadDropdownHandler = () => {
        if (this.state.selected_merchant == null || this.state.selected_brand== null || this.state.selected_category == null){
            this.handleNotificationClick("tr", 3, "Please select all fields");
        }
        else{
            this.setState({
                uploadDropdown: true,
                loading: true
            }, this._refreshUnmapped_View())
        }
        
    }

    toggleErrorModel() {
        this.setState({
            errorModel: !this.state.errorModel
        });
    }

    downloadReport(){
        console.log(this.state.report_file_name);
        this.downloadReportCSV.bind(this, 1, this.state.report_file_name);
    }

    _refreshUnmapped_View() {
        if ($.fn.DataTable.isDataTable('#unmappedViewTable')) {
            $('#unmappedViewTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL') + '/brandemi/get_unmapped_data_new',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id,
                category: this.state.selected_category,
                brand: this.state.selected_brand,
                merchant: this.state.selected_merchant
            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                raw_display_data: response.data,
                changedItems: []
            });
            $('#unmappedViewTable').DataTable();
            //  {
            //     "oLanguage": {
            //         "sEmptyTable": "Nothing to map"
            //     }
            // }
            this.setState({
                loading: false
            });
            this.preAppender();
        });
    }

    toggleNoErrorModel() {
        this.setState({
            noErrorModel: !this.state.noErrorModel
        });
    }

    gotoUploadedFile(){
        let pusher = '/admin/brand-viewer/' + this.state.file_id_got
        this.props.history.push(pusher)
    }


    render() {
        console.log(this.state.selected_merchant);
        // console.log(this.state.selected_party);
        let diskaro = false;
        if (this.state.isSubmit == true){
            diskaro = true;
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        let unmapped_data = this.state.raw_display_data.map((value,index) => {
            //this.preAppender(this, value[0].item_no);
            //console.log(this.state.raw_display_data[index][1][0].sku);
            /*this.setState({
                changedItems: {...this.state.changedItems, [index]:this.state.raw_display_data[index][1][0].sku}//,
                //isChange: true
            });*/
            let optioner = value[1].map((value2,index) => {
                    return(
                        <option value={value2.sku + "$" + value2.brand + "$" + value2.description + "$" + value2.category} key={index+1 + "_" + value2.sku}>{"brand: " + value2.brand + " desc: " + value2.description + " sku: " + value2.sku + " category: " + value2.category}</option>
                    );
                });
            
            //let indicator = "All";
            return (
                    <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value[0].merchant_sku}</td>
                    <td>{value[0].merchant_description}</td>
                    <td>{value[0].merchant_category}</td>
                    <td>    
                        <select name="permissionType" className="form-control clmatch" onChange={this.handleChange.bind(this, value[0].item_no)}>
                            {/*console.log(value[0][1].brand)*/}
                            {/*, value[0].merchant_sku, value[0].merchant_brand, value[0].merchant_description, value[0].merchant_mrp*/}
                            {optioner}
                            {/*<option value="All" >{value[1][0].sku + " " + value[1][0].brand + " " + value[1][0].description + " " + value[1][0].mrp}</option>*/}
                            {/*selected={val.permission == "All"}*/}
                            {/*<option value="Self" >{value[1][1].sku + " " + value[1][1].brand + " " + value[1][1].description + " " + value[1][1].mrp}</option>*/}
                            {/*selected={val.permission=="Self"}*/}
                            {/*<option value="None">{value[1][2].sku + " " + value[1][2].brand + " " + value[1][2].description + " " + value[1][2].mrp}</option>*/}
                            {/* selected={val.permission=="None"}*/}
                            {/*<option value="None1">{value[1][3].sku + " " + value[1][3].brand + " " + value[1][3].description + " " + value[1][3].mrp}</option>*/}
                            {/*<option value="None2">{value[1][4].sku + " " + value[1][4].brand + " " + value[1][4].description + " " + value[1][4].mrp}</option>*/}
                        </select>
                    </td>
                </tr>
            )
        });

        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });


        let merchant_list_render = this.state.merchant_list;
        let brand_list_render = this.state.brand_list;
        let category_list_render = this.state.category_list;

        let some_value = "Mapper Data";

        let admin_shower = () => {
            if(decoded.userGroup == 1){
                return(
                <div className="row top-margin-30">
                    <div className="col-md-3">
                        <Label>Select Merchant</Label>
                        <Select name={"party_name_1"}
                            // defaultValue={this.state.selectedMerchValues}
                            onChange={this.updateMerchant.bind(this)}
                            options={merchant_list_render}
                            placeholder="Select merchant"
                            // isClearable={true}
                        />
                    </div>  
                    <div className="col-md-3">
                        <Label>Select brand</Label>
                        <Select name={"party_name_2"}
                            // defaultValue={this.state.selectedMerchValues}
                            onChange={this.updateBrand.bind(this)}
                            options={brand_list_render}
                            placeholder="Select brand"
                            // isClearable={true}
                        />
                    </div>
                    <div className="col-md-3">
                        <Label>Select category</Label>
                        <Select name={"party_name_3"}
                            // defaultValue={this.state.selectedMerchValues}
                            onChange={this.updateCategory.bind(this)}
                            options={category_list_render}
                            placeholder="Select category"
                            // isClearable={true}
                        />
                    </div>
                    <div className="col-md-3">
                        <button onClick={this.uploadDropdownHandler} className="btn btn-primary btn-capitalize pull-right">Map products</button>
                    </div>
                    </div>
                )
            }
            else if (decoded.userGroup == 2){
                return(
                    <div className="row top-margin-30"> 
                        <div className="col-md-3">
                            <Label>Select brand</Label>
                            <Select name={"party_name_2"}
                                // defaultValue={this.state.selectedMerchValues}
                                onChange={this.updateBrand.bind(this)}
                                options={brand_list_render}
                                placeholder="Select brand"
                                // isClearable={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <Label>Select category</Label>
                            <Select name={"party_name_3"}
                                // defaultValue={this.state.selectedMerchValues}
                                onChange={this.updateCategory.bind(this)}
                                options={category_list_render}
                                placeholder="Select category"
                                // isClearable={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <button onClick={this.uploadDropdownHandler} className="btn btn-primary btn-capitalize pull-right">Map products</button>
                        </div>
                        </div>
                    )
            }
        }

        return (
            <div className="content longcontent">
                <CommonNavbar/>
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip /> 
                <div className="col-md-12" >
                    <div className="card p-t-5">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            <h4 className="title pull-left">Product Mapper</h4>
                            
                        </div>
                        
                        <div className="content">
                            
                                {admin_shower()}
                                
                            
                        </div>
                    </div>
                </div>
                <Collapse isOpen={this.state.uploadDropdown}>
                    <div className="col-md-12">
                        <div className="card">
                            <div className="header">
                                <h4 className="title pull-left">{some_value}</h4>
                            </div>
                            <div className="content">
                                <div className='sweet-loading'>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                </div>
                                <div className="content table-full-width table-responsive">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <table className="table table-striped table-hover" id="unmappedViewTable">
                                                <thead>
                                                <tr>
                                                    <th>Sr No.</th>
                                                    <th>Merchant SKU</th>
                                                    <th>Merchant Description</th>
                                                    <th>Merchant Category</th>
                                                    <th>Closest Brand Data Match</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {unmapped_data}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Button color="primary" className={'btn-capitalize'} disabled={diskaro} onClick={this.mappingHandler}>Map Data</Button>{' '}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
        </div>
        );
    }
}

export default MerchantBrandProductMapper;